export default __webpack_public_path__ + "static/media/Accessed-Icon-Check.f6ad0fe8.svg";